import VideoCard from './VideoCard';

const VideoGrid = () => {
  const videos = [
    {
      id: '1',
      title: 'Market Outlook Discussion: Key Considerations for Investors',
      network: 'Fox News',
      date: 'March 15, 2024',
      thumbnail: 'https://img.youtube.com/vi/S8rJq0I6M20/maxresdefault.jpg',
      videoId: 'S8rJq0I6M20',
      topic: 'Market Analysis'
    },
    {
      id: '2',
      title: 'Federal Reserve Policy and Potential Market Implications',
      network: 'Fox News',
      date: 'February 28, 2024',
      thumbnail: 'https://img.youtube.com/vi/p0g7PwSZMU0/maxresdefault.jpg',
      videoId: 'p0g7PwSZMU0',
      topic: 'Federal Policy'
    },
    {
      id: '3',
      title: 'Tech Stocks: Navigating the Current Landscape',
      network: 'CBS Detroit',
      date: 'February 15, 2024',
      thumbnail: 'https://img.youtube.com/vi/-Wjtc6w5FT0/maxresdefault.jpg',
      videoId: '-Wjtc6w5FT0',
      topic: 'Technology'
    },
    {
      id: '4',
      title: 'Estate Planning Considerations for 2024',
      network: 'CBS Detroit',
      date: 'January 30, 2024',
      thumbnail: 'https://img.youtube.com/vi/g03e1BiofnA/maxresdefault.jpg',
      videoId: 'g03e1BiofnA',
      topic: 'Estate Planning'
    },
    {
      id: '5',
      title: 'Healthcare Costs and Retirement Planning Considerations',
      network: 'Fox News',
      date: 'January 12, 2024',
      thumbnail: 'https://img.youtube.com/vi/hixxYomgJMU/maxresdefault.jpg',
      videoId: 'hixxYomgJMU',
      topic: 'Healthcare'
    },
    {
      id: '6',
      title: 'Municipal Bonds in a Changing Rate Environment',
      network: 'Fox News',
      date: 'December 20, 2023',
      thumbnail: 'https://img.youtube.com/vi/eZ4qXofw-Qc/maxresdefault.jpg',
      videoId: 'eZ4qXofw-Qc',
      topic: 'Fixed Income'
    },
    {
      id: '7',
      title: 'Approaches to Investing During Market Volatility',
      network: 'CBS Detroit',
      date: 'December 10, 2023',
      thumbnail: 'https://img.youtube.com/vi/RuIPABZDa7w/maxresdefault.jpg',
      videoId: 'RuIPABZDa7w',
      topic: 'Investment Strategy'
    },
    {
      id: '8',
      title: 'Retirement Income Planning Considerations',
      network: 'Fox News',
      date: 'November 25, 2023',
      thumbnail: 'https://img.youtube.com/vi/0TDHXGkkyJM/maxresdefault.jpg',
      videoId: '0TDHXGkkyJM',
      topic: 'Retirement Planning'
    },
    {
      id: '9',
      title: 'Tax-Aware Portfolio Management Concepts',
      network: 'Fox Live',
      date: 'November 15, 2023',
      thumbnail: 'https://img.youtube.com/vi/Hg_5XuwJ1Tk/maxresdefault.jpg',
      videoId: 'Hg_5XuwJ1Tk',
      topic: 'Tax Strategy'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
          Featured TV Appearances
        </h2>
        <p className="text-center text-gray-600 mb-12 text-lg">
          Watch Dan's commentary and educational discussions on major financial networks
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
        <p className="text-xs text-gray-500 text-center mt-8 max-w-3xl mx-auto">
          TV appearances are for educational and informational purposes only. The views expressed are those of Dan Casey as of the date of the broadcast and are subject to change. They do not constitute investment advice or a recommendation to buy or sell any securities. Bridgeriver Advisors is not affiliated with or endorsed by any television network shown above.
        </p>
      </div>
    </section>
  );
};

export default VideoGrid;
